module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAA9klEQVQokZWQLUtEQRSGn3s1iIgYRMRwqj9g06n+A2FNNsEgiFEOi1HZMWoQtIhBDf4Im1PFaHOKxWKQFRa5lnOXYdbPF4YzvOd5GJiqaRrKpBiOgVXgQtT2yn1VSimGM2Azq/qi1vtWSjEcArtjT8OGqJ2PSSmGHnDwhdBmRdRuR1KKYQs4+UFosyxqj9XTXb8L3PxBAHgBOvU/BIB5YL8G1oEjYPiL8OHcaf4Rr8CsA89+loBF7waiNg1QuzDT3j3botYBdrKuSjHMkYE1MJUBTTHx/UQuDYDJDFgoZpu3kSRqQ6ALXALXwIND98CV92ui9g7wCXfQTp7Yzn4JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/回主页图标.png
// module id = Vx+j
// module chunks = 1